<template>
  <PageLayout>
    <PageHeader
      :title="$t(`Common.title.useRule`)"
      :breadcrumb="[
        {
          title: `${$t('Common.title.homeTitle')}`,
        },
        {
          title: `${this.$t(
            `Common.title.${this.$route.params?.type?.toString()}`
          )}`,
        },
      ]"
    />
    <div class="px-4">
      <div
        class="px-4"
        style="font-size: 18px"
        v-html="$t('Common.title.useRuleStr')"
      ></div>
    </div>

    <template slot="actions">
      <div class="m-page-footer">
        <m-button
          block
          type="primary"
          ghost
          size="large"
          @click="onInstructions"
          class="m-footer_button"
          >{{ this.$t('Common.action.instructions') }}</m-button
        >

        <m-button
          block
          type="primary"
          ghost
          size="large"
          @click="onClose"
          class="m-footer_button"
          >{{ this.$t('Common.action.disagree') }}</m-button
        >

        <m-button
          block
          type="primary"
          size="large"
          class="m-footer_button"
          @click="onNext"
          >{{ this.$t('Common.action.agree') }}</m-button
        >
      </div>
    </template>
  </PageLayout>
</template>

<script>
import PageLayout from "@/components/PageLayout.vue";
import PageHeader from 'common/components/Layout/web/PageHeader.vue';

export default {
  name: 'Home',
  components: {
    PageLayout,
    PageHeader,
  },
  data() {
    return {};
  },
  methods: {
    onInstructions() {
      // 打開浏览器新窗口
      window.open('saautocase.pdf', '_blank');
    },
    onClose() {
      this.$router.back();
    },
    onNext() {
      this.$router.push({
        name: 'search',
        params: {
          type: this.$route.params?.type,
        },
      });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.m-page-footer {
  display: flex;
  flex-direction: row;
}
.m-footer_button {
  margin-left: 8px;
}

@media screen and (max-width: 576px) {
  ::v-deep(.web-page__content.has-footer) {
    padding-bottom: 8px;
  }
  .m-footer_button {
    margin-bottom: 8px;
    margin-left: 0;
  }
  ::v-deep(.web-page-actions__content) {
    justify-content: center;
    display: contents;
  }
  .m-page-footer {
    display: flex;
    flex-direction: column;
  }
}
</style>
